import { render, staticRenderFns } from "./HeadcountAgeChart.vue?vue&type=template&id=a6a40334&scoped=true&"
import script from "./HeadcountAgeChart.vue?vue&type=script&lang=js&"
export * from "./HeadcountAgeChart.vue?vue&type=script&lang=js&"
import style0 from "./HeadcountAgeChart.vue?vue&type=style&index=0&id=a6a40334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a40334",
  null
  
)

export default component.exports